module.exports = __webpack_public_path__ + "static/media/headstorm_bolt_white.d7f13bdc.svg";